import { Component } from '../../scripts/component';

export class ConnectedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadContent();
        }
      });
    });
    observer.observe(this);
  }

  loadContent() {
    if (this.getAttribute('data-connected-products-loaded')) return;
    const template = this.querySelector('template');
    if (!template) return;
    const content = template.content.cloneNode(true);
    if (!content) return;
    this.setAttribute('data-connected-products-loaded', 'true');
    template.after(content);
  }
}

if (!customElements.get('connected-products')) {
  customElements.define('connected-products', ConnectedProducts);
}
